import { createContext, useContext, useState, useEffect } from "react"
import { UserContext } from "../UserContext/UserContex"
// import { RequestOneContext } from "../RequestOneContext/RequestOneContext"
import axios from "axios"

export const NotificacaoContext = createContext()

export const NotificacaoProvider = ({ children }) => {
    const { user } = useContext(UserContext)
    // const { requestOne } = useContext(RequestOneContext)

    const [notificacoes, setNotificacoes] = useState([])

    const fetchNotificacoes = async () => {
        if (!user || !user.id) return

        try {
            const response = await axios.post(`http://${window.location.hostname}:3000/v2/getNotificacoesUser`,
                {
                    id_user: user.id,
                    dataCadastro: user.dataCadastro || user.data_criacao
                }
            )
            if (response?.data && Array.isArray(response.data.dados)) {
                setNotificacoes(response.data.dados)
            } else {
                setNotificacoes([])
            }
        } catch (error) {
            console.error("Erro ao buscar notificações:", error)
            setNotificacoes([])
        }
    }

    const lerNotificacao = (id) => {
        if (!id) return

        try {
            axios.post(`http://${window.location.hostname}:3000/v2/lerNotificacao`, { id_user: user.id, id_notificacao: id })
                .then((response) => {
                    if (response?.data && response.data.sucesso) {
                        fetchNotificacoes()
                    }
                })
        } catch (error) {
            console.error("Erro ao marcar notificação como lida:", error)
        }
    }

    useEffect(() => {
        fetchNotificacoes()
    }, [user])

    return (
        <NotificacaoContext.Provider value={{ notificacoes, setNotificacoes, fetchNotificacoes, lerNotificacao }}>
            {children}
        </NotificacaoContext.Provider>
    )
}
